module.exports = __webpack_public_path__ + "static/media/16_l_par_0_7.5.a39aae01.png";